import { render, staticRenderFns } from "./payment_exclusions.vue?vue&type=template&id=63ee2335"
import script from "./payment_exclusions.vue?vue&type=script&lang=js"
export * from "./payment_exclusions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src2585860866/src/clients/ap3/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('63ee2335')) {
      api.createRecord('63ee2335', component.options)
    } else {
      api.reload('63ee2335', component.options)
    }
    module.hot.accept("./payment_exclusions.vue?vue&type=template&id=63ee2335", function () {
      api.rerender('63ee2335', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/sites/brand/settings/payment_exclusions.vue"
export default component.exports